import React from 'react';

const Services = () => {
  return (
    <section id="services" className="py-16 bg-gray-50">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 animate-on-scroll">
          Services
        </h2>
        <p className="section-description animate-on-scroll">
          Une solution logistique complète, de l'enlèvement à la livraison de vos colis
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Service 1 */}
          <div className="bg-white p-8 rounded-lg service-card animate-on-scroll text-left">
            <div className="service-icon mb-6">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <circle cx="30" cy="30" r="25" stroke="#000000" strokeWidth="2" fill="none"/>
                <circle cx="30" cy="30" r="5" fill="#000000"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-3">Suivi en Temps Réel</h3>
            <p className="text-gray-600 font-inter">
              Gardez un œil sur vos colis à chaque étape, de l'enlèvement à la livraison finale.
            </p>
          </div>
          
          {/* Service 2 */}
          <div className="bg-white p-8 rounded-lg service-card animate-on-scroll text-left">
            <div className="service-icon mb-6">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <rect x="10" y="15" width="40" height="30" rx="3" stroke="#000000" strokeWidth="2" fill="none"/>
                <line x1="10" y1="25" x2="50" y2="25" stroke="#000000" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-3">Paiement à la Livraison</h3>
            <p className="text-gray-600 font-inter">
              Le destinataire règle en espèces à la réception ; nous collectons le montant et le reversons au marchand.
            </p>
          </div>
          
          {/* Service 3 */}
          <div className="bg-white p-8 rounded-lg service-card animate-on-scroll text-left">
            <div className="service-icon mb-6">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <rect x="15" y="10" width="30" height="40" rx="3" stroke="#000000" strokeWidth="2" fill="none"/>
                <line x1="15" y1="15" x2="45" y2="15" stroke="#000000" strokeWidth="2"/>
                <line x1="15" y1="45" x2="45" y2="45" stroke="#000000" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-3">Gestion des Retours</h3>
            <p className="text-gray-600 font-inter">
              Simplifiez le processus de retour pour vous et vos clients avec notre solution intégrée.
            </p>
          </div>
          
          {/* Service 4 */}
          <div className="bg-white p-8 rounded-lg service-card animate-on-scroll text-left">
            <div className="service-icon mb-6">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <path d="M10,30 Q10,10 30,10 Q50,10 50,30 Q50,50 30,50 Q10,50 10,30" stroke="#000000" strokeWidth="2" fill="none"/>
                <circle cx="20" cy="25" r="2" fill="#000000"/>
                <circle cx="40" cy="25" r="2" fill="#000000"/>
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-3">Support Client Réactif</h3>
            <p className="text-gray-600 font-inter">
              Notre équipe dédiée est là pour vous assister marchands, livreurs et clients afin d'assurer le bon déroulement des livraisons.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
